import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { website } from '@cld/typography';
import { useAnalytics } from '../../../../hooks/useAnalytics';

export interface LinkProps {
  label: string,
  img: string,
  url: string,
  'data-test': string,
}

const Anchor = styled.a`
  display: flex;
  flex-direction: column;
  padding: ${globalTheme.spacing.xs};
  margin: ${globalTheme.spacing.xxs} calc(${globalTheme.spacing.lg} * 2);

  &, &:visited {
    ${website.headlines.md.contrastInvert};
  }

  img {
    height: calc(${globalTheme.spacing.lg} * 2);
    margin-bottom: ${globalTheme.spacing.md};
  }
`;

export const Link: FC<LinkProps> = ({ label, img, url, 'data-test': dataTest }) => {
  const analytics = useAnalytics();

  return (
    <Anchor
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-test={dataTest}
      onClick={() => analytics('learn more', `clicked on ${label} icon to learn more about ${label} doc`)}
    >
      <img src={img} alt={img} />
      <div>{label}</div>
    </Anchor>
  );
};
